<template lang="html">

  <section class="login row-center ais" :style="`background:url(${background}) center/cover no-repeat`"
    :onelogin="brand.OneLoginForCandidatos">

    <div class="left row-center" :style="`background:url(${background}) center/cover no-repeat`">
      <h2 class="logo row-center"><img :src="logoselected" alt="Logo" :size="logosize"></h2>
    </div>

    <div class="buttons-mobile">
      <button class="button-mobile -alumnos column-center" @click="setform('alumnos')" :active="how == 'alumnos'">
        <img src="/static/img/icons/alumno.svg" alt="">
        <span>{{brand.logintexts[lang].estudiantes}}</span>
      </button>
      <button v-if="!!!brand.OneLoginForCandidatos" class="button-mobile -antiguos column-center"
        @click="setform('antiguos')" :active="how == 'antiguos'">
        <icon-antiguos-alumnos></icon-antiguos-alumnos>
        <span>{{brand.logintexts[lang].antiguos}}</span>
      </button>
      <button class="button-mobile -empresas column-center" @click="setform('empresas')" :active="how == 'empresas'">
        <img src="/static/img/icons/empresas.svg" alt="">
        <span>{{brand.logintexts[lang].empresas}}</span>
      </button>
    </div>

    <div class="right" :how="how">

      <div class="form-el row-center -antiguos" :active="how == 'antiguos'" v-if="!!!brand.OneLoginForCandidatos">
        <div class="contenedor-formulario">

          <template v-if="!!ownlogin && !!ownlogin.hasEgresado && !!!godmode">
            <div class="contenedor-login-terceros">

              <h2 class="title-dato">{{$t('login.iniciar_sesion')}}</h2>
              <p v-html="ownlogin.textoEgresados[lang]"></p>
              <a class="btn -solid-primary"
                :href="server+'/AuthUniversidades/solicitudAcceso.aspx?portal=alumno'">{{$t('login.acceder')}}</a>
            </div>
          </template>

          <login-alumno @revealRecuperar="showRecuperarPop('antiguos')" v-if="godmode | !ownlogin | (brand.ownFormLogin && brand.ownFormLogin.includes('antiguos'))" :how="'antiguos'"></login-alumno>


        </div>
        <button class="show-form" @click="setform('antiguos')">
          <span>{{brand.logintexts[lang].antiguos}}</span>
        </button>
      </div>

      <div class="form-el row-center -alumnos" :active="how == 'alumnos'">
        <div class="contenedor-formulario">
          <template v-if="!!ownlogin && !!ownlogin.hasEstudiante && !!!godmode">
            <div class="contenedor-login-terceros" v-if="brand.logintexts">
              <h1>{{brand.logintexts[lang].estudiantes}}</h1>
              <h2 class="title-dato">{{$t('login.iniciar_sesion')}}</h2>
              <p v-html="ownlogin.textoEstudiantes[lang]"></p>
              <a class="btn -solid-primary" :href="server+'/AuthUniversidades/solicitudAcceso.aspx?portal=alumno'">
                <template v-if="ownlogin.botonEstudiantes && ownlogin.botonEstudiantes[lang]">
                  {{ownlogin.botonEstudiantes[lang]}}
                </template>
                <template v-else>
                  {{$t('login.acceder')}}
                </template>
              </a>
              <a class="link lostpass" target="_blank" :href="ownlogin.linkpassword"
                v-if="ownlogin.linkpassword">{{$t('login.contrasena_olvidada')}}</a>
            </div>
          </template>
          <login-alumno @revealRecuperar="showRecuperarPop('alumnos')" v-else :how="'alumnos'"></login-alumno>
        </div>
        <button class="show-form" @click="setform('alumnos')" v-if="brand.logintexts">
          <span>{{brand.logintexts[lang].estudiantes}}</span>
        </button>
      </div>

      <div class="form-el row-center -empresas" :active="how == 'empresas'">
        <div class="contenedor-formulario">
          <login-empresa @revealRecuperar="showRecuperarPop('empresa')"></login-empresa>
        </div>
        <button class="show-form" @click="setform('empresas')">
          <span>{{brand.logintexts[lang].empresas}}</span>
        </button>
      </div>

      <div class="cover-recuperacion row-center" v-if="showRecuperar">

        <div class="popup">

          <a class="cerrar -small" @click="showRecuperar= false">✕</a>

          <template v-if="brand.textoRecoveryPass && brand.textoRecoveryPass[lang] && how == 'antiguos'">
            <p class="recovery-saml" v-html="brand.textoRecoveryPass[lang]"></p>
          </template>


          <div class="contenedor-input">
            <label for="">{{$t('login.introduce_email')}}</label>
            <input type="text" v-model="emailRecuperar" @keyup.enter="validar">
            <span class="error" v-if="showerror">{{$t('login.email_mal')}}</span>
          </div>

          <a class="btn -solid-primary" @click="validar" :loading="loading">{{$t('login.recuperar_pass')}}</a>



        </div>

      </div>

    </div>




    <popup-rgpd :how="how"></popup-rgpd>

    <popup-seleccion-empresa></popup-seleccion-empresa>

  </section>

</template>

<script lang="js">

  import formularioEmpresa from '@/components/views/login/form-empresa';
  import formularioAlumno from '@/components/views/login/form-alumno';

  import popupRGPD from '@/components/views/login/popup-rgpd';

  import popupSeleccionEmpresa from '@/components/views/login/popup-seleccion-empresa';

  import iconAntiguosAlumnos from '@/components/parts/icons/icon-antiguos-alumnos';

  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'login',
    mounted() {
      let posibles = ['antiguos', 'alumnos', 'empresas'];
      (posibles.some(el => this.$route.params.id == el)) ? this.how = this.$route.params.id : null;
      this.setIsMobile();
      window.addEventListener('resize', this.setIsMobile)
    },
    data() {
      return {
        data: false,
        how: 'alumnos',
        showRecuperar: false,
        emailRecuperar: '',
        showerror: false,
        mobile: false,
        typeRecoveryPass: '',
        loading: false
      }
    },
    components: {
      'login-empresa': formularioEmpresa,
      'login-alumno': formularioAlumno,
      'popup-rgpd': popupRGPD,
      'popup-seleccion-empresa': popupSeleccionEmpresa,
      'icon-antiguos-alumnos': iconAntiguosAlumnos
    },
    methods: {
      ...mapActions(['recuerdoPass', 'eraseError', 'recuerdoPassAlumno']),
      setform(value) {
        this.how = value;
        this.$route.params.id = value;
        window.history.pushState('Login', 'Login', `/login/${value}`);
      },
      showRecuperarPop(data) {
        this.showRecuperar = true;
        this.typeRecoveryPass = data;
        this.emailRecuperar = '';
      },
      validar() {
        if (this.emailRecuperar.includes('@')) {

          this.loading = true;

          if (this.typeRecoveryPass == 'empresa') {

            this.recuerdoPass(this.emailRecuperar.trim()).then(r => {
              if (r) {
                this.emailRecuperar = '';
                this.showRecuperar = false;
              }
              this.loading = false;
            });

          } else {

            this.recuerdoPassAlumno(this.emailRecuperar.trim()).then(r => {
              if (r) {
                this.emailRecuperar = '';
                this.showRecuperar = false;
              }
              this.loading = false;
            });

          }

        } else {
          this.showerror = true;
        }



      },
      setIsMobile() {
        this.mobile = (document.documentElement.clientWidth <= 920);
      }
    },
    computed: {
      ...mapGetters({
        logo: 'getLogo',
        colors: 'basicColors',
        style: 'getStyles',
        background: 'getBackground',
        logosize: 'getLogoSize',
        ownlogin: 'getOwnlogin',
        server: 'getServer',
        brand: 'getBrand',
        darkmode: 'getDarkSide',
        godmode: 'getGodmodeStatus',
        lang: 'getLanguage'
      }),
      logoselected() {



        let logo = (!!this.brand.logoLogin) ? this.brand.logoLogin : this.logo

        if (this.darkmode) {
          logo = this.brand.logodarkmode;
        }

        return logo;
      },
    },
    watch: {
      'how': function () {
        this.eraseError();
      }
    }
  }

</script>
<style scoped lang="scss">
  @import "@/assets/css/colors.scss";

  .login {
    height: calc(100vh - 68px);

  }

  .left {
    background: url(/static/img/background.jpg) center/cover no-repeat;
    width: 33.3333333%;
    height: auto;
  }

  .right {
    width: 66.66666666%;
    position: relative;
    overflow: hidden;
  }

  .logo {
    width: 100%;
  }

  .logo img {
    min-width: 100px;
    display: inline-block;
    width: 100%;
  }

  .logo img[size="small"] {
    min-width: 130px;
    max-width: 130px;
    display: inline-block;
  }

  .logo img[size="medium"] {
    min-width: 280px;
    max-width: 280px;
    display: inline-block;
  }

  .logo img[size="big"] {
    min-width: 320px;
    max-width: 320px;
    display: inline-block;
  }

  $base-width:150px;

  .form-el {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    padding-right: $base-width;
    transition: .5s;
    overflow: hidden;
  }

  .form-el.-antiguos {
    z-index: 3;
    width: calc(100% - 300px);
    padding-left: $base-width;
  }


  .form-el.-alumnos {
    width: calc(100% - 150px);
    z-index: 2;
    padding-left: $base-width * 2;
  }

  .form-el.-empresas {
    width: 100%;
    z-index: 1;
    padding-left: $base-width * 3;
  }

  .right[how="alumnos"] .form-el.-antiguos {
    transform: translateX(calc(-100% + 150px));
    -ms-transform: translateX(-100%) translateX(150px);
  }

  .right[how="empresas"] .form-el.-alumnos {
    transform: translateX(calc(-100% + 300px));
    -ms-transform: translateX(-100%) translateX(300px);
  }

  .right[how="empresas"] .form-el.-antiguos {
    transform: translateX(calc(-100% + 150px));
    -ms-transform: translateX(-100%) translateX(150px);
  }

  [onelogin=true] .right[how="empresas"] .form-el.-alumnos {
    transform: translateX(calc(-100% + 160px));
  }

  .contenedor-formulario {
    max-width: 340px;
    width: 100%;
    transition: .5s;
  }

  .show-form {
    background: transparent;
    width: $base-width;
    height: 100%;
    display: inline-block;
    border: none;
    outline: none;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }

  .show-form span {
    font-size: 30px;
    text-transform: uppercase;
    font-weight: 700;
    width: 80vh;
    position: absolute;
    bottom: 0px;
    text-align: left;
    transform-origin: left;
    transform: rotate(-90deg);
  }

  .cover-recuperacion {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 20;
    padding: 15px;

    .popup {
      padding: 30px;
      background: $white;
      text-align: center;
      min-width: 300px;
      max-width: 500px;
      box-shadow: 2px 3px 11px 1px rgba(0, 0, 0, 0.7);
      position: relative;
    }

  }

  .buttons-mobile {
    display: none;
  }


  .recovery-saml {
    margin-bottom: 20px;
    display: inline-block;
    font-style: italic;
    font-size: 14px;

  }

  .lostpass {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }


  h1 {
    text-align: left;
    width: 100%;
    display: inline-block;
    margin-bottom: 20px;
    text-transform: uppercase;
    font-weight: bold;
  }


  @media screen and (max-width: 1420px) {

    $base-width: 100px;


    .form-el {
      padding-right: 100px;
    }

    .show-form {
      width: 100px;
    }

    .form-el {
      padding-right: $base-width;
    }

    .form-el.-antiguos {
      width: calc(100% - 200px);
      padding-left: $base-width;
    }


    .form-el.-alumnos {
      width: calc(100% - 100px);
      padding-left: $base-width * 2;
    }

    .form-el.-empresas {
      padding-left: $base-width * 3;
    }

    .right[how="alumnos"] .form-el.-antiguos {
      transform: translateX(calc(-100% + 100px));
      -ms-transform: translateX(-100%) translateX(100px);
    }

    .right[how="empresas"] .form-el.-alumnos {
      transform: translateX(calc(-100% + 200px));
      -ms-transform: translateX(-100%) translateX(200px);
    }

    .right[how="empresas"] .form-el.-antiguos {
      transform: translateX(calc(-100% + 100px));
      -ms-transform: translateX(-100%) translateX(100px);
    }


    .show-form {
      width: $base-width;
    }


  }


  @media screen and (max-width: 1220px) {

    $base-width: 75px;

    .form-el {
      padding-right: $base-width;
    }

    .show-form {
      width: $base-width;
    }

    .form-el {
      padding-right: $base-width;
    }

    .form-el.-antiguos {
      width: calc(100% - 150px);
      padding-left: $base-width;
    }


    .form-el.-alumnos {
      width: calc(100% - 75px);
      padding-left: $base-width * 2;
    }

    .form-el.-empresas {
      padding-left: $base-width * 3;
    }

    .right[how="alumnos"] .form-el.-antiguos {
      transform: translateX(calc(-100% + 75px));
      -ms-transform: translateX(-100%) translateX(75px);
    }

    .right[how="empresas"] .form-el.-alumnos {
      transform: translateX(calc(-100% + 150px));
      -ms-transform: translateX(-100%) translateX(150px);
    }

    .right[how="empresas"] .form-el.-antiguos {
      transform: translateX(calc(-100% + 75px));
      -ms-transform: translateX(-100%) translateX(75px);
    }


    .show-form {
      width: $base-width;
    }



  }

  @media screen and (max-width: 1024px) {
    .login {
      height: auto;
      min-height: 100vh;
      align-items: flex-start;
      justify-content: flex-start;
      background: none !important;
      flex-direction: column;

      .left {
        width: 100%;
        padding: 50px 20px;
      }

      .buttons-mobile {
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        justify-content: center;
        width: 100%;

        .button-mobile {
          width: 33.33333%;
          text-transform: uppercase;
          padding: 10px;
          border: none;

          img,
          svg {
            height: 30px;
            margin-bottom: 10px;
            display: inline-block;
          }
        }
      }

      .right {
        flex-grow: 1;
        width: 100%;
        display: flex;
        align-self: stretch;
        flex-direction: column;
        width: 100%;



        .form-el {
          padding-right: 0;
          padding-left: 0;
          display: none;
          position: relative;
          left: auto;
          top: auto;
          height: 100%;
          flex-grow: 1;
          padding: 15px 0;

          &[active=true] {
            display: flex;
          }

          &.-alumnos {
            width: 100%;
          }

          &.-antiguos {
            width: 100%;
          }
        }

        .show-form {
          display: none;
        }
      }

    }

    .login[onelogin=true] .buttons-mobile .button-mobile {
      width: 50%;
    }

  }

  @media screen and (max-width: 567px) {

    .login .left {
      padding: 25px 10px;
    }



    .login .buttons-mobile .button-mobile {
      padding: 10px 6px;

      span {
        font-size: 12px;
      }

      &.-alumnos,
      &.-empresas {
        width: 30%;
      }

      &.-antiguos {
        width: 40%;
      }
    }

    .login[onelogin=true] .buttons-mobile .button-mobile {
      width: 50%;
    }


  }
</style>


// WEBPACK FOOTER //
// src/components/views/login/login.vue